// ============================================================
// SHOPPABLE VIDEO JS — thumbnail 100% em imagem
// O MP4 só é carregado quando o usuário abre o popup.
// ============================================================

(function () {
  function getTingleModal() {
    if (window.tingle && window.tingle.modal) {
      return window.tingle.modal;
    }

    if (typeof tingle !== 'undefined' && tingle.modal) {
      return tingle.modal;
    }

    return null;
  }

  function loadPopupVideo(modal) {
    const video = modal.modal.querySelector('.sv-story-video');

    if (!video || video.tagName !== 'VIDEO') return null;

    const source = video.dataset.src;

    if (source && !video.getAttribute('src')) {
      video.src = source;
      video.removeAttribute('data-src');
      video.load();
    }

    video.currentTime = 0;
    video.muted = true;
    video.play().catch(function () {});

    return video;
  }

  function openStoryModal(storyEl) {
    const TingleModal = getTingleModal();

    if (!TingleModal) {
      console.warn('[ShopableVideo] tingle não encontrado.');
      return;
    }

    const clone = storyEl.cloneNode(true);
    let activeVideo = null;

    const modal = new TingleModal({
      cssClass: ['shopable-video', 'sv-modal'],
      closeMethods: ['overlay', 'escape', 'button'],
      closeLabel: 'Fechar',

      onOpen: function () {
        activeVideo = loadPopupVideo(modal);
      },

      onClose: function () {
        if (activeVideo && activeVideo.tagName === 'VIDEO') {
          activeVideo.pause();
          activeVideo.removeAttribute('src');
          activeVideo.load();
        }

        setTimeout(function () {
          modal.destroy();
        }, 300);
      }
    });

    modal.setContent(clone.outerHTML);
    modal.open();
  }

  // Delegação de clique: funciona também se a seção for recarregada
  // dentro do editor de temas da Shopify.
  document.addEventListener('click', function (event) {
    const slide = event.target.closest('shopable-video');

    if (!slide) return;

    // Deixa links/botões internos seguirem seu comportamento normal.
    if (
      event.target.closest('a, button, button-quickview, product-form, form')
    ) {
      return;
    }

    const popupWrapper = slide.querySelector('.video-item__popup');
    if (!popupWrapper) return;

    const storyEl = popupWrapper.querySelector('.sv-story-wrap');
    if (!storyEl) return;

    openStoryModal(storyEl);
  });
})();
